import { apiClient } from '~/api/client';

export type CompanyStateTransactionsParams = {
  license: string;
  state: string;
  period: Period;
};

export type IndexResponse = {
  meta: {
    units: number;
    purchase: number;
    refinance: number;
    offices: number;
    officers: number;
  };
};

export const index = async ({ license, state, period }: CompanyStateTransactionsParams) =>
  apiClient.get<IndexResponse>(
    `/companies/${license}/loan_transactions?state=${state}&period=${period}`
  );
